export default {
  containerStyle: {
    width: '300px',
    height: '132px',
    position: 'relative',
    display: 'inline-block',
    zIndex: 1
  },
  textarea: {
    display: 'inline-block',
    boxSizing: 'border-box',
    wordWrap: 'break-word',
    wordBreak: 'break-all',
    resize: 'none',
    verticalAlign: 'top',
    width: '300px',
    height: '100px',
    fontSize: '16px',
    padding: '5px 10px'
  },
  padStyle: {
    boxSizing: 'border-box',
    display: 'inline-block',
    margin: 0,
    padding: 0,
    outline: 'none',
    position: 'absolute',
    zIndex: 2,
    top: '100px',
    right: '0',
    textAlign: 'right',
    lineHeight: '32px',
    color: '#aaa'
  },
  disabled: {
    cursor: 'not-allowed',
    border: '1px solid #ddd',
    borderColor: '#ddd',
    backgroundColor: '#ddd',
    color: '#aaa'
  },
  half: {
    width: '150px'
  }
};



// WEBPACK FOOTER //
// ./src/Components/Textarea/style.js